import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { generateKey } from '@/utils';
import LocaleSelector from '@/components/LocaleSelector/LocaleSelector';
import {
  Menu,
  LogoContainer,
  Logo,
  Sections,
  PlaceholderWrapper,
  MenuOuterWrapper,
  Flag,
  TwoColumnsWrapper,
  SocialLinksWrapper,
  TermsLinks,
  TermsLink,
} from '@/components/GlobalMenu/Mobile/MenuOuter.style';
import SocialIcon from '@/components/Footer/SocialIcon';
import CopyRight from '@/components/GlobalMenu/CopyRight';
import logo from '../../../assets/images/sp-logo-black.svg';

import MenuOuterItem from './MenuOuterItem';
import SearchBar from '../SearchBar';
import SearchResult from './SearchResult';
import Placeholder from '../../Placeholder';

/**
 * メニュー > 各メニュー表示 (SP 版 ヘッダー / フッター共用コンポーネント)
 *   ヘッダー、フッター表示項目: 美容診断、商品情報など (両者で表示項目が異なる)
 *   ヘッダー表示内容、且つ、フッター非表示内容
 *     1. 商標ロゴ、2. 検索フォーム
 */
class MenuOuter extends React.Component {
  static defaultProps = {
    availableRegions: [],
    copy: {},
    footerCopyright: null,
    screenSize: null,
    secondaryLinks: [],
    closeMenu: null,
    isFooterMenu: false,
    footerSocialLinks: [],
  };

  static propTypes = {
    availableRegions: PropTypes.arrayOf(PropTypes.shape()),
    copy: PropTypes.shape(),
    locale: PropTypes.string.isRequired,
    menu: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    nestedMenuOpen: PropTypes.bool.isRequired,
    openGroup: PropTypes.func.isRequired,
    screenSize: PropTypes.number,
    // コピーライト表示内容
    footerCopyright: PropTypes.string,
    // 利用規約、個人情報保護方針の表示内容
    secondaryLinks: PropTypes.arrayOf(PropTypes.shape()),
    closeMenu: PropTypes.func,
    isFooterMenu: PropTypes.bool,
    footerSocialLinks: PropTypes.arrayOf(PropTypes.shape()),
  };

  state = {
    results: undefined,
  };

  setResult = results => {
    this.setState({ results });
  };

  toggleSection = name => {
    this.setState({ [name]: !this.state[name] });
  };

  openLocaleSelector = () => {
    const { availableRegions, copy, openGroup } = this.props;
    openGroup(copy.language_region, { availableRegions });
  };

  render() {
    // Placeholder 表示に使用する
    const placeholderStart = 1;
    const placeholderEnd = 8;

    const { results } = this.state;
    const {
      availableRegions,
      closeMenu,
      menu,
      openGroup,
      nestedMenuOpen,
      locale,
      isFooterMenu,
      screenSize,
      footerSocialLinks,
      footerCopyright,
      secondaryLinks,
    } = this.props;
    const currentRegion = availableRegions.find(region => region.languages.some(lang => lang.locale === locale));

    return (
      <Menu show={!nestedMenuOpen}>
        {!isFooterMenu && (
          <React.Fragment>
            {/* 商標ロゴ表示部分 */}
            <LogoContainer>
              {!logo ? (
                <Placeholder w="100%" h="60px" />
              ) : (
                <Link to={`/${locale}`} href={`/${locale}`} onClick={closeMenu}>
                  <Logo src={logo} />
                </Link>
              )}
            </LogoContainer>
            {/* 検索フォーム */}
            <SearchBar setResult={this.setResult} />
          </React.Fragment>
        )}
        {isFooterMenu ? (
          <Sections className="footerMenu">
            <PlaceholderWrapper direction="column">
              {!(menu && _.find(menu, item => _.get(item, 'label'))) &&
                new Array(placeholderEnd - placeholderStart)
                  .fill(null)
                  .map((item, index) => (
                    <Placeholder w="270px" h="20px" m="0 0 26px 0" key={generateKey('placeholder', index)} />
                  ))}
            </PlaceholderWrapper>
            {menu.map((menuItem, index) => (
              <MenuOuterWrapper key={generateKey('menu-outer', index)}>
                {_.get(menuItem, 'label') && (
                  <MenuOuterItem
                    key={menuItem.label}
                    menuItem={menuItem}
                    openGroup={openGroup}
                    isFooterMenu={isFooterMenu}
                  />
                )}
              </MenuOuterWrapper>
            ))}
            <TwoColumnsWrapper>
              <LocaleSelector position={screenSize > 1 ? 'top' : 'top-right'} full isFooterMenu />
              <SocialLinksWrapper>
                {!(
                  footerSocialLinks &&
                  _.find(footerSocialLinks, item => _.get(item, 'url')) &&
                  _.find(footerSocialLinks, item => _.get(item, 'type'))
                ) && (
                  <PlaceholderWrapper direction="row">
                    <Placeholder w="30px" h="30px" m="0 30px 0 0" />
                    <Placeholder w="30px" h="30px" />
                  </PlaceholderWrapper>
                )}
                {footerSocialLinks &&
                  footerSocialLinks.map(({ url, type }, index) => (
                    <SocialIcon key={generateKey('social-link', index)} type={type} url={url} />
                  ))}
              </SocialLinksWrapper>
            </TwoColumnsWrapper>
          </Sections>
        ) : (
          <React.Fragment>
            {results ? (
              <SearchResult data={results} />
            ) : (
              <Sections>
                <PlaceholderWrapper direction="column">
                  {!(menu && _.find(menu, item => _.get(item, 'label'))) &&
                    new Array(placeholderEnd - placeholderStart)
                      .fill(null)
                      .map((item, index) => (
                        <Placeholder w="270px" h="20px" m="0 0 26px 0" key={generateKey('placeholder', index)} />
                      ))}
                </PlaceholderWrapper>
                {menu.map((menuItem, index) => (
                  <MenuOuterWrapper key={generateKey('menu-outer', index)}>
                    <MenuOuterItem
                      key={menuItem.label}
                      menuItem={menuItem}
                      openGroup={openGroup}
                      isFooterMenu={isFooterMenu}
                    />
                  </MenuOuterWrapper>
                ))}

                {currentRegion ? (
                  <Flag src={currentRegion.icon} onClick={this.openLocaleSelector} />
                ) : (
                  <Placeholder w="30px" h="20px" />
                )}
              </Sections>
            )}
          </React.Fragment>
        )}
        {isFooterMenu && (
          <TermsLinks>
            {!secondaryLinks || !_.find(secondaryLinks, item => _.get(item, 'label')) ? (
              <PlaceholderWrapper direction="row">
                <Placeholder w="40px" h="10px" m="12px 0 0 0" />
                <Placeholder w="40px" h="10px" m="12px 0 0 20px" />
              </PlaceholderWrapper>
            ) : (
              <React.Fragment>
                {secondaryLinks.map(({ label, external, url }, index) => (
                  <TermsLink key={generateKey('tems-link', index)}>
                    {external ? (
                      <a href={url} target="_blank">
                        {/* 個人情報保護方針 */}
                        {label}
                      </a>
                    ) : (
                      <Link to={`/${locale}${url}`} href={`/${locale}${url}`}>
                        {/* 利用規約 */}
                        {label}
                      </Link>
                    )}
                  </TermsLink>
                ))}
              </React.Fragment>
            )}
          </TermsLinks>
        )}
        {isFooterMenu && (
          <React.Fragment>
            {!footerCopyright ? (
              <Placeholder w="180px" h="11px" m="20px 0 20px 0" />
            ) : (
              <CopyRight footerCopyright={footerCopyright} />
            )}
          </React.Fragment>
        )}
      </Menu>
    );
  }
}

const mapState = state => ({
  availableRegions: state.siteOptions.availableRegions,
  copy: state.siteOptions.siteCopyGeneral,
  locale: state.locale,
  footerSocialLinks: state.siteOptions.footerSocialLinks,
  // コピーライト表示内容
  footerCopyright: state.siteOptions.footerCopyright,
  // 利用規約、個人情報保護方針の表示内容
  secondaryLinks: state.siteOptions.footerSecondaryLinks,
});

export default connect(mapState)(MenuOuter);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MenuOuter.js